import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import useMaster from 'hook/useMaster';
import { useApi } from 'libs/data-access/src/api/useApi';
import { IFlightOnlineBookingList, IHotelOnlineBookingList } from 'libs/data-access/types';
import { IFilterState, TFilterBookedBy, TBookingStatus, TFilterDateType } from 'types';
import { usePagination } from 'hook/usePagination';
import { useFlightBookingData } from 'libs/data-access';

type IOnlineBookingFilter = {
  service: string;
  startDate: string;
  endDate: string;
  bookingBy: string;
  bookingStatus: string;
  lastName: string;
  pnr: string;
  bookingRefNo: string;
  ticketNo: string;
};

export default function useOnlineBooking() {

  const location = useLocation();
  const status: TBookingStatus = location.pathname.split("/")[2].toUpperCase() as TBookingStatus;


  const {
    serviceTypes,
    getServiceTypes,
    getAllGroupTypes,
    getAffiliatedByGroup,
  } = useMaster();
  const {
    getData,
    postData
  } = useApi();
  const {
    getFlightBookingData
  } = useFlightBookingData();

  const dateTypeOptions: { label: string; value: TFilterDateType }[] = [{
    label: "Booking Date",
    value: "BOOKING_DATE"
  },
  {
    label: "Travel Date",
    value: "TRAVEL_DATE"
  }];
  const bookedByOptions: { label: string; value: TFilterBookedBy }[] = [{
    label: "Customer",
    value: "NORMAL_USER"
  },
  {
    label: "Affiliate",
    value: "AFFILIATE"
  }];
  const filterBookingStatusList: { label: string; value: TBookingStatus | "" }[] = [{
    label: "All",
    value: ""
  },
  {
    label: "Success",
    value: "SUCCESS"
  },
  {
    label: "Failed",
    value: "FAILED"
  },
  {
    label: "Cancelled",
    value: "CANCELED"
  },
  {
    label: "Ticketing Pending",
    value: "TICKETING_PENDING"
  },
  {
    label: "To be Refunded",
    value: "TO_BE_REFUNDED"
  },
  {
    label: "Refunded",
    value: "REFUNDED"
  }];

  const DefaultFilter: IFilterState = {
    service: { label: "Service", value: "", type: "Single", option: serviceTypes },
    dateType: { label: "Date Type", value: "", type: "Single", option: dateTypeOptions },
    startDate: { label: "Start Date", value: "", type: "Date" },
    endDate: { label: "End Date", value: "", type: "Date" },
    bookedBy: { label: "Booked By", value: "", type: "Single", option: bookedByOptions },
    //  affiliateGroup : { label: "Affiliate Group", value: "", type: "Single", relationChild:["affiliate"], getDropDownListFunction: getAllGroupTypes },
    //  affiliate: { label: "Affiliate", value: "", type: "Multiple", getDropDownListByIdFunction: (id) => id  ? getAffiliatedByGroup(id) : Promise.reject("Invalid ID provided") },
    bookingStatus: { label: "Booking Status", value: "", type: "Single", option: filterBookingStatusList, additionalProps: { defaultValue: "" } },
    lastName: { label: "Last Name", value: "", type: "Text" },
    pnr: { label: "PNR ", value: "", type: "Text" },
    referenceNo: { label: "Booking Ref No.", value: "", type: "Text" },
    ticketNo: { label: "Ticket No.", value: "", type: "Text" }
  };

  const [loading, setLoading] = useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  // const [hotelBookingList, setHotelBookingList] = useState<IHotelOnlineBookingList[]>([]);
  // const [flightBookingList, setFlightBookingList] = useState<IFlightOnlineBookingList[]>([]);

  // const [status, setStatus] = useState<string>("SUCCESS");
  const [filterState, setFilterState] = useState<IFilterState>(DefaultFilter);


  useEffect(() => {
    getServiceTypes();
  }, []);

  useEffect(() => {
    setFilterState(prev => ({
      ...prev,
      service: { ...prev.service, value: "FLIGHT", option: serviceTypes }
    }));

    // console.log(location.pathname);
    // const status: TBookingStatus = location.pathname.split("/")[2].toUpperCase() as TBookingStatus;
    // setStatus(status);

    // getFlightBookingList(status);
  }, [serviceTypes, location.pathname]);

  // useEffect(() => {
  //   // const status: TBookingStatus = location.pathname.split("/")[2].toUpperCase() as TBookingStatus;

  //   if (filterState.service.value === "FLIGHT") {
  //     // getFlightBookingList(status);
  //   } else {
  //     // getHotelBookingList(status);
  //   };
  // }, [filterState.service.value]);


  // HANDLER FUNCTION 
  const handleChangeFilter = (
    key: keyof IFilterState | "default",
    value: string
  ) => {
    if (key === "default") {
      setFilterState(DefaultFilter);
    } else {
      let filter = JSON.parse(JSON.stringify(filterState));

      if (key === "startDate") {
        filter["endDate"].value = "";
        filter[key].value = value;
        setFilterState(filter);
      }
      // if(key === "affiliateGroup" ){
      //     filter["affiliate"].value = "";
      //     filter[key].value = value;
      //     getAffiliatedByGroup([value]).then((res) => {
      //        filter["affiliate"].option = res ?? [];
      //        setFilterState(filter);
      //     });
      // }
      else {
        filter[key].value = value;
        setFilterState(filter);
      };
    };
  };

  const handleSubmitFilter = () => {
    if (filterState?.service?.value === "FLIGHT") {
      // getFlightBookingList();
    } else {
      // getHotelBookingList();
    };
  };


  return {
    status,
    loading,
    isBtnLoading,
    filterState,
    setFilterState,
    handleChangeFilter,
    handleSubmitFilter,
  };

};